import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../assets/product-list.css';

const projectsData = [
    {
        id: 5,
        title: "AIMeetingPro",
        description: "AIMeetingPro lets any one has talent to be pass the interview of any company without any anxiety and stress.",
        imageUrl: "/images/AIMeetingPro2.png",
        tags: ["AI", "Interview", "Productivity","Desktop App"],
        demoUrl: "https://aimeetingpro.stemcellsoft.com/",
        status: "Live"
    },
    {
        id: 1,
        title: "StemCellSoft",
        description: "Creative ideas are like stem cells capable of developing into any organ – full of vitality and brimming with limitless possibilities.",
        imageUrl: "/images/stemcellsoft.png",
        tags: ["Official Website", "Blog"],
        demoUrl: "https://stemcellsoft.com/",
        status: "Live"
    },
    {
        id: 2,
        title: "ChatGPT Saver",
        description: "Effortlessly save and organize your conversations from ChatGPT, Claude, DeepSeek, Grok and Gemini. Save and organize your ChatGPT conversations for free, helping you use ChatGPT more efficiently.",
        imageUrl: "/images/chrome-extension-gptsaver.png",
        tags: ["AI", "ChatGPT", "Chrome Extension"],
        demoUrl: "https://chromewebstore.google.com/detail/gdjkcifbngophcngpidahgodkfdeffnh?utm_source=item-share-cb",
        status: "Live"
    },
    {
        id: 3,
        title: "AI Todo List",
        description: "An AI consultant that helps you build and manage your todo list, guiding you to achieve your goals effectively.",
        imageUrl: "/images/aitodolist.jpeg",
        tags: ["Productivity", "Management", "Todo List"],
        demoUrl: "https://aitodolist.stemcellsoft.com",
        status: "Prototype"
    },
    {
        id: 4,
        title: "HealFoods",
        description: "Search and find healthy foods and recipes, when you are sick or want to eat healthy.",
        imageUrl: "/images/healthfood1.jpg",
        tags: ["Health", "Food", "tools"],
        demoUrl: "https://healfoods.net/",
        status: "Live"
    }
    // {
    //     id: 5,
    //     title: "A day Friends",
    //     description: "Smart travel planning tool generating personalized itineraries based on budget, time, and preferences.",
    //     imageUrl: "/images/adayfriends.png",
    //     tags: ["Travel", "AI Planning", "Personalization"],
    //     demoUrl: "#",
    //     status: "Concept"
    // }
];

const ProductList = () => {
    const heroRef = React.useRef(null);
    const [filter, setFilter] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    
    const statusFilters = [
        { value: 'all', label: 'All Projects' },
        { value: 'Live', label: 'Live' },
        { value: 'In Development', label: 'In Development' },
        { value: 'Planning', label: 'Planning' },
        { value: 'Concept', label: 'Concept' },
        { value: 'Prototype', label: 'Prototype' }
    ];
    
    // 根据过滤条件和搜索项筛选项目
    const filteredProjects = projectsData
        .filter(project => filter === 'all' || project.status === filter)
        .filter(project => 
            project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            project.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
            project.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()))
        );

    return (
        <div className="product-list-page">

<style jsx="true">{`
                .landing-page {
                    font-family: 'Segoe UI', 'Helvetica Neue', sans-serif;
                    color: #333;
                    overflow-x: hidden;
                }
                
                h1, h2, h3, h4, h5, h6 {
                    font-weight: 600;
                }
                
                .section {
                    padding: 100px 0;
                    opacity: 0;
                    transform: translateY(20px);
                    transition: opacity 0.6s ease, transform 0.6s ease;
                }
                
                .section.animated {
                    opacity: 1;
                    transform: translateY(0);
                }
                
                .container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 20px;
                }
                
                /* Hero Section */
                .hero-section-stemcell {
                    background: linear-gradient(135deg, #4a4a4a 0%, #2d2d2d 100%);
                    color: white;
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    padding: 0;
                    position: relative;
                    overflow: hidden;
                }
                
                .hero-content-stemcell {
                    position: relative;
                    z-index: 2;
                    max-width: 600px;
                }
                
                .hero-title-stemcell {
                    font-size: 4rem;
                    margin-bottom: 1.5rem;
                    line-height: 1.2;
                    font-weight: 800;
                    animation: fadeInUp 1s ease;
                }
                
                .hero-subtitle-stemcell {
                    font-size: 1.5rem;
                    margin-bottom: 2rem;
                    line-height: 1.6;
                    font-weight: 400;
                    animation: fadeInUp 1.2s ease;
                }
                
                .hero-cta {
                    display: inline-block;
                    background: #e0e0e0;
                    color: #2d2d2d;
                    font-weight: 600;
                    font-size: 1.1rem;
                    padding: 15px 40px;
                    border-radius: 50px;
                    text-decoration: none;
                    transition: all 0.3s ease;
                    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
                    animation: fadeInUp 1.4s ease;
                }
                
                .hero-cta:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
                }
                
                .hero-particles {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                }
                
                .particle {
                    position: absolute;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.1);
                }
                
                .stem-cell-svg {
                    position: absolute;
                    right: 5%;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 400px;
                    height: 400px;
                    z-index: 2;
                    animation: floatAnimation 6s ease-in-out infinite;
                }
                
                @keyframes floatAnimation {
                    0% { transform: translateY(-50%) translateX(0); }
                    50% { transform: translateY(-50%) translateX(-10px); }
                    100% { transform: translateY(-50%) translateX(0); }
                }
                
                /* Molecule Decorations */
                .molecule-svg {
                    position: absolute;
                    width: 150px;
                    height: 150px;
                    opacity: 0.4;
                    z-index: 1;
                }
                
                .molecule-1 {
                    top: 10%;
                    left: 10%;
                    animation: rotateSlow 20s linear infinite;
                }
                
                .molecule-2 {
                    bottom: 10%;
                    left: 15%;
                    animation: rotateSlow 25s linear infinite reverse;
                }
                
                @keyframes rotateSlow {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
                
                /* Featured Projects */
                .featured-section {
                    background: #f4f4f4;
                }
                
                .featured-title {
                    text-align: center;
                    margin-bottom: 4rem;
                    font-size: 2.5rem;
                    color: #333;
                }
                
                .featured-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
                    gap: 30px;
                }
                
                .featured-card {
                    background: white;
                    border-radius: 15px;
                    overflow: hidden;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
                    transition: all 0.3s ease;
                }
                
                .featured-card:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 15px 40px rgba(45, 45, 45, 0.1);
                }
                
                .featured-image {
                    position: relative;
                    height: 220px;
                    overflow: hidden;
                }
                
                .featured-image img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.5s ease;
                }
                
                .featured-card:hover .featured-image img {
                    transform: scale(1.05);
                }
                
                .featured-status {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    background: rgba(0, 0, 0, 0.75);
                    color: white;
                    padding: 8px 16px;
                    border-radius: 30px;
                    font-size: 0.8rem;
                    font-weight: 500;
                }
                
                .featured-content {
                    padding: 30px;
                }
                
                .featured-project-title {
                    font-size: 1.5rem;
                    margin-bottom: 15px;
                    color: #222;
                }
                
                .featured-description {
                    color: #666;
                    margin-bottom: 20px;
                    line-height: 1.6;
                }
                
                .featured-tags {
                    display: flex;
                    flex-wrap: wrap;
                    margin-bottom: 20px;
                    gap: 10px;
                }
                
                .featured-tag {
                    background: #e0e0e0;
                    color: #2d2d2d;
                    padding: 5px 15px;
                    border-radius: 30px;
                    font-size: 0.8rem;
                }
                
                .featured-actions {
                    display: flex;
                    justify-content: flex-end;
                }
                
                .btn-view-featured {
                    display: inline-flex;
                    align-items: center;
                    background: linear-gradient(135deg, #4a4a4a 0%, #2d2d2d 100%);
                    color: white;
                    padding: 10px 20px;
                    border-radius: 30px;
                    text-decoration: none;
                    font-weight: 500;
                    font-size: 0.9rem;
                    transition: all 0.3s ease;
                }
                
                .btn-view-featured i {
                    margin-left: 10px;
                }
                
                .btn-view-featured:hover {
                    transform: translateX(5px);
                }
                
                /* Mission Section */
                .mission-section {
                    background: white;
                    text-align: center;
                }
                
                .mission-title {
                    font-size: 2.5rem;
                    margin-bottom: 1.5rem;
                    color: #333;
                }
                
                .mission-subtitle {
                    font-size: 1.2rem;
                    max-width: 800px;
                    margin: 0 auto 3rem;
                    color: #666;
                    line-height: 1.7;
                }
                
                .values-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
                    gap: 30px;
                }
                
                .value-card {
                    background: #f9f9f9;
                    padding: 40px 30px;
                    border-radius: 15px;
                    text-align: center;
                    transition: all 0.3s ease;
                }
                
                .value-card:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.05);
                }
                
                .value-icon {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 80px;
                    height: 80px;
                    background: linear-gradient(135deg, #4a4a4a 0%, #2d2d2d 100%);
                    color: white;
                    border-radius: 50%;
                    font-size: 2rem;
                    margin-bottom: 20px;
                }
                
                .value-title {
                    font-size: 1.5rem;
                    margin-bottom: 15px;
                    color: #333;
                }
                
                .value-description {
                    color: #666;
                    line-height: 1.6;
                }
                
                /* Stats Section */
                .stats-section {
                    background: linear-gradient(135deg, #4a4a4a 0%, #2d2d2d 100%);
                    color: white;
                    text-align: center;
                }
                
                .stats-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
                    gap: 30px;
                }
                
                .stat-item {
                    padding: 20px;
                }
                
                .stat-number {
                    font-size: 3.5rem;
                    font-weight: 800;
                    margin-bottom: 10px;
                }
                
                .stat-label {
                    font-size: 1.2rem;
                    opacity: 0.9;
                }
                
                /* Contact Section */
                .contact-section {
                    background: #f9f9f9;
                    text-align: center;
                }
                
                .contact-title {
                    font-size: 2.5rem;
                    margin-bottom: 1.5rem;
                    color: #333;
                }
                
                .contact-subtitle {
                    font-size: 1.2rem;
                    max-width: 800px;
                    margin: 0 auto 3rem;
                    color: #666;
                    line-height: 1.7;
                }
                
                .contact-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
                    gap: 30px;
                }
                
                .contact-card {
                    background: white;
                    padding: 40px 30px;
                    border-radius: 15px;
                    text-align: center;
                    transition: all 0.3s ease;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
                }
                
                .contact-card:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 15px 40px rgba(45, 45, 45, 0.1);
                }
                
                .contact-icon {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 70px;
                    height: 70px;
                    background: linear-gradient(135deg, #4a4a4a 0%, #2d2d2d 100%);
                    color: white;
                    border-radius: 50%;
                    font-size: 1.8rem;
                    margin-bottom: 20px;
                }
                
                .contact-method {
                    font-size: 1.3rem;
                    margin-bottom: 15px;
                    color: #333;
                }
                
                .contact-detail {
                    color: #666;
                    line-height: 1.6;
                    margin-bottom: 20px;
                }
                
                .contact-link {
                    display: inline-block;
                    background: linear-gradient(135deg, #4a4a4a 0%, #2d2d2d 100%);
                    color: white;
                    padding: 10px 25px;
                    border-radius: 30px;
                    text-decoration: none;
                    font-weight: 500;
                    transition: all 0.3s ease;
                }
                
                .contact-link:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
                }
                
                /* Animations */
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @media (max-width: 992px) {
                    .stem-cell-svg {
                        opacity: 0.3;
                        right: 0;
                        width: 300px;
                        height: 300px;
                    }
                    
                    .hero-content-stemcell {
                        position: relative;
                        z-index: 5;
                    }
                }
                
                @media (max-width: 768px) {
                    .hero-title-stemcell {
                        font-size: 3rem;
                    }
                    
                    .hero-subtitle-stemcell {
                        font-size: 1.3rem;
                    }
                    
                    .section {
                        padding: 70px 0;
                    }
                    
                    .featured-grid, .values-grid, .stats-grid, .contact-grid {
                        grid-template-columns: 1fr;
                    }
                    
                    .stem-cell-svg {
                        opacity: 0.2;
                        width: 200px;
                        height: 200px;
                    }
                }

                /* Filter Section */
                .filter-section {
                    background: #f4f4f4;
                    padding: 30px 0;
                }

                .search-input {
                    border: 1px solid #4a4a4a;
                }

                .search-button {
                    background: #4a4a4a;
                    color: white;
                }

                .filter-button {
                    background: #e0e0e0;
                    color: #2d2d2d;
                    border: none;
                    padding: 8px 16px;
                    border-radius: 20px;
                    margin: 0 5px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }

                .filter-button.active {
                    background: #4a4a4a;
                    color: white;
                }

                /* Project Cards */
                .project-card {
                    background: white;
                    border-radius: 15px;
                    overflow: hidden;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
                    transition: all 0.3s ease;
                }

                .project-card:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 15px 40px rgba(45, 45, 45, 0.1);
                }

                .project-status {
                    background: rgba(45, 45, 45, 0.9);
                    color: white;
                }

                .project-tag {
                    background: #e0e0e0;
                    color: #2d2d2d;
                }

                .btn-view-project {
                    background: linear-gradient(135deg, #4a4a4a 0%, #2d2d2d 100%);
                    color: white;
                }

                /* No Results */
                .no-results {
                    text-align: center;
                    padding: 50px 0;
                    color: #4a4a4a;
                }

                .no-results i {
                    color: #2d2d2d;
                    margin-bottom: 20px;
                }
            `}</style>
            {/* Hero Section */}
            <section ref={heroRef} className="hero-section-stemcell section animated">
                <div className="hero-particles">
                    {Array.from({ length: 20 }).map((_, i) => (
                        <div
                            key={i}
                            className="particle"
                            style={{
                                width: `${Math.random() * 50 + 10}px`,
                                height: `${Math.random() * 50 + 10}px`,
                                left: `${Math.random() * 100}%`,
                                top: `${Math.random() * 100}%`,
                                opacity: Math.random() * 0.5 + 0.1,
                                animation: `float ${Math.random() * 10 + 5}s linear infinite`,
                                animationDelay: `${Math.random() * 5}s`
                            }}
                        />
                    ))}
                </div>
                
                {/* Stem Cell SVG */}
                <div style={{
                    position: 'absolute',
                    right: '5%',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '400px',
                    height: '400px',
                    zIndex: 2,
                    animation: 'floatAnimation 6s ease-in-out infinite'
                }}>
                    <svg viewBox="0 0 400 400">
                        <defs>
                            <linearGradient id="dnaGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#4a4a4a" />
                                <stop offset="100%" stopColor="#2d2d2d" />
                            </linearGradient>
                            <radialGradient id="cellGrad" cx="50%" cy="50%" r="50%">
                                <stop offset="0%" stopColor="#4a4a4a" stopOpacity="0.8" />
                                <stop offset="100%" stopColor="#2d2d2d" stopOpacity="0.4" />
                            </radialGradient>
                            <radialGradient id="nucleusGrad" cx="50%" cy="50%" r="50%">
                                <stop offset="0%" stopColor="#333333" stopOpacity="0.8" />
                                <stop offset="100%" stopColor="#1a1a1a" stopOpacity="0.6" />
                            </radialGradient>
                        </defs>
                        
                        {/* Main Cell */}
                        <circle cx="200" cy="200" r="150" fill="url(#cellGrad)" />
                        
                        {/* Nucleus */}
                        <circle cx="200" cy="200" r="60" fill="url(#nucleusGrad)" />
                        
                        {/* Organelles */}
                        <circle cx="240" cy="160" r="12" fill="#FF7F50" opacity="0.7" />
                        <circle cx="170" cy="230" r="10" fill="#77DD77" opacity="0.7" />
                        <circle cx="150" cy="150" r="8" fill="#FF7F50" opacity="0.7" />
                        <circle cx="250" cy="240" r="11" fill="#77DD77" opacity="0.7" />
                        
                        {/* Cell membrane extensions */}
                        <line x1="200" y1="50" x2="200" y2="20" stroke="#8EC5FC" strokeWidth="2" opacity="0.5" />
                        <line x1="320" y1="150" x2="350" y2="140" stroke="#8EC5FC" strokeWidth="2" opacity="0.5" />
                        <line x1="100" y1="270" x2="70" y2="290" stroke="#8EC5FC" strokeWidth="2" opacity="0.5" />
                        <line x1="280" y1="280" x2="300" y2="310" stroke="#8EC5FC" strokeWidth="2" opacity="0.5" />
                    </svg>
                </div>
                
                <div className="container">
                    <div className="hero-content-stemcell">
                        <h1 className="hero-title-stemcell">Stem Cell Soft</h1>
                        <p className="hero-subtitle-stemcell">
                        Creative ideas are like stem cells capable of developing into any organ – full of vitality and brimming with limitless possibilities.
                        </p>
                        <a href="#featured" className="hero-cta">Discover Our Ideas</a>
                    </div>
                </div>
            </section>

            {/* 过滤和搜索区 */}
            <div id="featured" className="filter-section">
                <div className="container">
                    <div className="search-container">
                        <input 
                            type="text" 
                            placeholder="Search projects..." 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="search-input"
                        />
                        <button className="search-button">
                            <i className="fa-solid fa-magnifying-glass"></i>
                        </button>
                    </div>
                    
                    <div className="filter-buttons">
                        {statusFilters.map(statusFilter => (
                            <button 
                                key={statusFilter.value}
                                className={`filter-button ${filter === statusFilter.value ? 'active' : ''}`}
                                onClick={() => setFilter(statusFilter.value)}
                            >
                                {statusFilter.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
            
            {/* 项目列表区 */}
            <div className="projects-section">
                <div className="container">
                    {filteredProjects.length === 0 ? (
                        <div className="no-results">
                            <i className="fa-solid fa-search fa-3x"></i>
                            <p>No matching projects found. Try different search criteria.</p>
                        </div>
                    ) : (
                        <div className="projects-grid">
                            {filteredProjects.map(project => (
                                <div className="project-card" key={project.id}>
                                    <div className="project-image">
                                        <img src={project.imageUrl} alt={project.title} />
                                        <div className="project-status">{project.status}</div>
                                    </div>
                                    <div className="project-content">
                                        <h3 className="project-title">{project.title}</h3>
                                        <p className="project-description">{project.description}</p>
                                        <div className="project-tags">
                                            {project.tags.map((tag, index) => (
                                                <span className="project-tag" key={index}>{tag}</span>
                                            ))}
                                        </div>
                                        <div className="project-actions">
                                            <a 
                                                href={project.demoUrl} 
                                                className="btn-view-project"
                                                target={project.demoUrl.startsWith('http') ? "_blank" : "_self"}
                                                rel={project.demoUrl.startsWith('http') ? "noopener noreferrer" : ""}
                                            >
                                                View Project
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            
            {/* 号召行动区 */}
            {/* <div className="cta-section">
                <div className="container">
                    <h2>有新的项目创意？</h2>
                    <p>随时欢迎探讨合作机会，或者查看我的开源贡献</p>
                    <div className="cta-buttons">
                        <a href="mailto:contact@example.com" className="btn-cta-primary">
                            <i className="fa-solid fa-envelope"></i>
                            联系我
                        </a>
                        <a href="https://github.com/yourusername" target="_blank" rel="noopener noreferrer" className="btn-cta-secondary">
                            <i className="fa-brands fa-github"></i>
                            GitHub
                        </a>
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default ProductList; 